import { useContext, useCallback } from "react";

import { TranslationContext } from "../../../contexts/TranslationContext";
import i18n from "../../../i18n";
import {
  getStaticTranslation,
  getStaticTemplateMatch,
  normalizeLang,
} from "../../../translations/registerStaticTranslations";

// Static-bundle lookup for the competitions embeddables.
//
// The components are SELF-CONTAINED (props in, markup out): they must render
// outside the app shell (tests, storybook-style embeds), so this reads the
// TranslationContext directly instead of the throwing useTranslation() hook —
// no provider simply means English source strings.
//
// tr(s): exact static lookup, falls back to the source sentence.
// trAny(s): exact lookup first, then the template-pattern matcher (composed
// sentences like "Real Madrid win 5–4 on penalties" / "Group A").
export const useCompetitionsTr = () => {
  const ctx = useContext(TranslationContext);
  const currentLanguage = (ctx && ctx.currentLanguage) || "en";
  const lang = normalizeLang((currentLanguage || "en").toLowerCase());

  const tr = useCallback(
    (s) => {
      if (!s) return s;
      if (lang === "en") return s;
      return getStaticTranslation(i18n, s, lang) || s;
    },
    [lang],
  );

  const trAny = useCallback(
    (s) => {
      if (!s) return s;
      if (lang === "en") return s;
      return (
        getStaticTranslation(i18n, s, lang) ||
        getStaticTemplateMatch(i18n, s, lang) ||
        s
      );
    },
    [lang],
  );

  return { tr, trAny, lang, currentLanguage };
};

export default useCompetitionsTr;
